import React from 'react';

import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import DataTabs from './documentation/DataTabs';

import Copyright from './furniture/Copyright'
import {useStyles}from './furniture/Dashboard-Config'
import AppBarAndDrawer from './furniture/AppBarAndDrawer'

import { useOvermind } from '../overmind';
import NewSessionLoader from './accountSelection/NewSessionLoader'

export default function Documentation() {
  const classes = useStyles();
  const { state, actions } = useOvermind();

  if(state.blockAccess){
    actions.updateFlag({'name':'redirectPath','payload':'/documentation'});
    return(<NewSessionLoader/>);
  }else{
    return (
      <div className={classes.root}>
        <AppBarAndDrawer/>
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth="lg" className={classes.container}>
              <Grid container spacing={2}>
              {/* Placeholder */}
              <Grid item xs={12} md={12} lg={12}>
                <Paper className={classes.paper}>
                  <Typography variant="h6" color="primary" gutterBottom >
                    Automated Documentation
                  </Typography>
                  <Typography variant="body1"  gutterBottom >
                  GTM Docs - Automated Documentation feature gives cross sectional snapshot of any tag, variable, or trigger in your GTM container.
                  <br/>
                  With the flexiblity to filter your views, customize what data is shown, and drill into any tag, variable or trigger to see implementation details anything you need to know is at your finger tips.
                  </Typography>
                </Paper>
              </Grid>

              {/* Documentation DataTables*/}
              <Grid item xs={12}>
                <Paper>
                  <DataTabs />
                </Paper>
              </Grid>

            </Grid>
            <Box pt={4}>
              <Copyright />
            </Box>
          </Container>
        </main>
      </div>
    );
  }
}
